import { Container, Box } from '@mui/material';
import Breadcrumbs from '@/components/Breadcrumbs';
import { useSearchDirectoryData } from '@/context/searchDirectory/SearchDirectoryDataContext';

export const BreadcrumbsSection = () => {
  const pageData = useSearchDirectoryData();
  const breadcrumbs =
    pageData.seoSegmentationBreadcrumbs.__typename === 'SEOSegmentationBreadcrumbsSuccess'
      ? pageData.seoSegmentationBreadcrumbs.breadcrumbs
      : null;

  if (!breadcrumbs) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: 'background.secondary',
        pb: { xs: 6, sm: 8 },
      }}>
      <Container maxWidth="lg">
        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </Container>
    </Box>
  );
};
